import React, { useContext, useEffect } from "react";
import TableLabels from "../../../layout/TableLabels";
import moment from "moment";
import { AppContext } from "../../../App";
import { DiscountAdjustment, formatDecimal } from "../../../hooks/Method";

const AccountsAndDetails = ({ setValues, values, sell }) => {
  const { settings } = useContext(AppContext);

  useEffect(() => {
    if (sell && sell.id) {
      // Total return amount without discount applied
      const returnTotal = values.returnItems
        .map((j) => parseFloat(j.returnAmt || 0))
        .reduce((a, b) => a + b, 0);

      const { discountOnReturn, refundAmt } = DiscountAdjustment(
        sell.subtotal,
        sell.disAmt,
        returnTotal
      );

      // Adjust tax amount;
      const refundTaxAmt =
        (returnTotal - discountOnReturn) * ((sell.taxRate || 0) / 100);

      setValues((j) => ({
        ...j,
        discAdj: formatDecimal(discountOnReturn, true),
        refundTaxAmt: formatDecimal(refundTaxAmt, true),
        refundAmt: formatDecimal(refundAmt + formatDecimal(refundTaxAmt), true),
      }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.returnItems]);

  return (
    <div className="flex justify-between">
      <div className="flex flex-col gap-4 text-gray-500 p-2">
        <div className="flex flex-col ml-1 pr-3">
          <span className="text-[16px] font-bold">
            Invoice No: {values.sellId}
          </span>
          <span className="text-[14px]">
            Sell Date: {moment(values.sellDate).format("MMM  DD, YYYY, h:mm A")}
          </span>
        </div>
        <div className="flex flex-col ml-1">
          <span className="text-[16px] font-bold">
            Customer:{" "}
            {values.customer
              ? values.customer.firstName + " " + values.customer.lastName
              : settings.defCustomer}
          </span>
          {settings.haveMultipleOutlet && (
            <span className="text-[14px]">
              Outlet: {values.outlet?.outletName}
            </span>
          )}
        </div>
      </div>

      <div className="min-w-[400px] p-2">
        <TableLabels
          options={[
            {
              label: "Discount Adjustment",
              value: `(-) $ ${values.discAdj}`,
              className: "text-gray-500 text-[16px] text-wider",
            },
            {
              label: "Total Return Tax",
              value: `(+) $ ${values.refundTaxAmt}`,
              className: "text-gray-500 text-[16px] ",
            },
            {
              label: "Return Total",
              value: `$ ${values.refundAmt}`,
              className: "text-red-500 text-[16px] uppercase font-semibold",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AccountsAndDetails;
